import { useState } from "react";
import { uploadBinary } from "../lib/api.js";

export function UploadDropzone({
  onUploaded,
}: {
  onUploaded: (id: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [status, setStatus] = useState<string>("");

  async function handleFiles(list: FileList | File[]) {
    const files = Array.from(list);
    if (files.length === 0) return;
    setBusy(true);
    setErr(null);
    const zipCount = files.filter((f) =>
      f.name.toLowerCase().endsWith(".zip"),
    ).length;
    const label =
      zipCount > 0 && files.length === 1
        ? `Unpacking ${files[0]!.name} and running triage…`
        : files.length > 1
          ? `Uploading ${files.length} files and running triage…`
          : `Uploading ${files[0]!.name} and running triage…`;
    setStatus(label);
    try {
      const r = await uploadBinary(files);
      onUploaded(r.sessionId);
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
      setStatus("");
    }
  }

  return (
    <div
      className="dropzone"
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        if (e.dataTransfer.files?.length) handleFiles(e.dataTransfer.files);
      }}
    >
      {busy ? (
        <p>{status}</p>
      ) : (
        <>
          <p>Drop a binary, folder-zip, or multiple files here</p>
          <p className="dim">or</p>
          <input
            type="file"
            multiple
            onChange={(e) => {
              if (e.target.files) handleFiles(e.target.files);
            }}
          />
          <p className="dim" style={{ marginTop: 16, fontSize: 12 }}>
            .zip is unpacked server-side; companion files land in the workspace
            just like <code>exegesis &lt;folder&gt;</code> in the CLI.
          </p>
        </>
      )}
      {err && <p className="error">{err}</p>}
    </div>
  );
}
